/**
 * `fileToDataUri` — leest een browser `File`-object als data-URI string
 * (`data:<mime>;base64,<bytes>`). Wrapper rond `FileReader.readAsDataURL`
 * met een nette Promise-API.
 *
 * Bedoeld voor de AAVA-intake-upload: de API neemt afbeeldingen aan als
 * `string[]` van data-URIs (zie `docs/aava-intake-api.md` §5.1).
 */

/**
 * Per-file maximum. Server-side hard cap voor `/message` is 10 MiB
 * voor de hele request inclusief base64-inflation (~33%). 8 MiB raw
 * bytes geeft ~10.7 MiB base64 → net over de limit als enige bestand,
 * dus we kiezen voor 6 MiB om wat ruimte over te houden voor de
 * text-payload en headers.
 */
export const MAX_FILE_SIZE_BYTES = 6 * 1024 * 1024;

export function fileToDataUri(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result === 'string') {
        resolve(result);
      } else {
        reject(new Error('FileReader leverde geen string terug'));
      }
    };
    reader.onerror = () => reject(reader.error ?? new Error('Read failed'));
    reader.readAsDataURL(file);
  });
}
